import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPatchServiceTypeArgs,
  IPatchServiceTypeResponseData,
} from "./patchServiceType.schema";

type SuccessResponse = ZealApiSuccessResponse<IPatchServiceTypeResponseData>;

export const patchServiceType = (axios: IAxiosInstance) => {
  return async (params: IPatchServiceTypeArgs) => {
    try {
      const { serviceTypeID, ...body } = params;
      const response = await axios.noRetry.patch<SuccessResponse>(
        `/service-types`,
        body,
        { params: { serviceTypeID } }
      );
      return response?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
